<div
  *ngIf="inputCompany.pmsColors == null || inputCompany.pmsColors.length === 0"
  class="d-flex justify-content-between container no-padding-left"
>
  <p class="no-margin">Geen drukkleuren gedefinieerd</p>
  <div class="flexer box clickable padding-left" (click)="addColor()">
    <mat-icon class="align-with-text" svgIcon="add"></mat-icon>
  </div>
</div>
<div class="color-wrapper justify-content-between container no-padding-left">
  <div *ngFor="let node of nodes; let last = last; let cIndex = index">
    <div class="d-flex">
      <mat-form-field class="no-margin" appearance="outline">
        <div class="d-flex">
          <input
            placeholder="Naam drukkleur"
            matInput
            [(ngModel)]="node.pmsColor.name"
            name="text"
            required
          />
          <div class="flexer clickable" (click)="removeColor(node.index)">
            <mat-icon svgIcon="close"></mat-icon>
          </div>
        </div>
      </mat-form-field>
      <div
        *ngIf="last"
        class="flexer box clickable padding-left push-down"
        (click)="addColor()"
      >
        <mat-icon svgIcon="add"></mat-icon>
      </div>
    </div>
  </div>
</div>
